import { Component, Input, OnInit } from '@angular/core';
import { BusinessAccountsService } from '../business-accounts.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-global-reach',
  templateUrl: './global-reach.component.html',
  imports: [CommonModule, UrlParamsPipe],
})
export class GlobalReachComponent implements OnInit {
  @Input() queryParams: any;
  globalReachPanelData:any;


  constructor(
    private businessAccountsService: BusinessAccountsService,
    private posthog: PosthogService
  ) {
    this.subscriptions = [];
  }

  subscriptions: Subscription[];
  ngOnInit(): void {
    this.businessAccountsService.globalReach$.subscribe(data => {
      if (data != null) {
        this.globalReachPanelData = data;
      }
    });
  }

  onGlobalReachCTAClick(): void {
    const action = this.globalReachPanelData?.component1?.[0]?.fields.button?.[0].fields.buttonText?.toLowerCase().replace(/\s+/g, '_') || 'learn_more';
    this.posthog.captureCTAClick(action, 'feature_section', {
      ctaText: this.globalReachPanelData?.component1?.[0]?.fields.button?.[0].fields.buttonText,
      destinationUrl: this.globalReachPanelData?.component1?.[0]?.fields.button?.[0].fields.redirectLink
    });
  }
}
